import React from 'react';
import Icon from '@mdi/react';
import { mdiMenuDown } from '@mdi/js';
import { observer } from 'mobx-react';
import { Table, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import stores from 'cd-eft/models/Stores';
import './ReachTable.scss';

const { waterwayDesignStore, designStore } = stores.AppStore;

interface IReachTableProps {
  tabs: any[];
  activeTab?: string;
  children: any;
  setTab: any;
  designType?: 'terrace' | 'waterway';
}

export const ReachTable = observer(({ tabs, activeTab, setTab, children }: IReachTableProps) => {
  return (
    <div className="reach-table-container">
      <div className="reach-tab-sections" role="navigation">
        <Nav tabs>
          {tabs.map((el, index) => (
            <NavItem key={`terrace-reach-table-tab-${index}`}>
              <NavLink
                className={`usa-button${activeTab === el.tab ? '' : ' usa-button--outline'}`}
                onClick={() => setTab(el.tab)}
                tag="button"
                active={activeTab === el.tab}
              >
                {el.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </div>
      <TabContent activeTab={activeTab}>{children}</TabContent>
    </div>
  );
});

export const ReachTableTabPane = observer(({ el, selectAll, children, activeTab, designType }) => (
  <TabPane key={`tabPane-${el.tab}`} tabId={el.tab}>
    <div className="usa-table-container--scrollable">
      <Table className="usa-table usa-table--borderless reach-table">
      <ReactTableThead el={el} selectAll={selectAll} activeTab={activeTab} designType={designType} />
      {/* TBODY */}
        {children}
      </Table>
    </div>
  </TabPane>
));

export const ReactTableThead = observer(({ el, selectAll, activeTab, designType }) => (
  <thead>
    <tr>
      <th className="narrow-td">
        <div className="text-center float-left">
          Select/
          <br />
          DeSelect All
        </div>
        <div className="dropdown">
          <Icon path={mdiMenuDown} size={1.2} />
          <div className="dropdown-content" id="dropdown-content">
            <span role="button" tabIndex={0} onClick={selectAll} className="select-all-text">
              Select/DeSelect All
            </span>
          </div>
        </div>
      </th>
      <th className="status-th">Status</th>
      {el.defaultCols.map((e, g) => (
        <th key={'th-' + g}>
          {e.title.split('\n').map((e2, g2) => (
            <div key={'th-div-' + g2}>
              {e2}
              <br />
            </div>
          ))}
        </th>
      ))}
      {(designType === 'waterway' || designType === "UGO" || (designType === 'terrace' && activeTab !== 'reach-view')) && <th className="narrow-td action-th">Action</th>}
      </tr>
  </thead>
));
